import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';

import CreateIcon from '@mui/icons-material/Create';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';
import SpeedDialMenu from '@ts-core/components/SpeedDialMenu';

import { useActivities, useActivityActions } from '../../hooks';
import ActivitiesTable from '../../components/ActivitiesTable';
import { ProfessorActivity } from '../../types';

interface ActivitiesPageRouteParams {
  courseId: string;
}

const ActivitiesPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const { courseId } = useParams<ActivitiesPageRouteParams>();
  const { activities, loading } = useActivities({ courseId });
  const { onToggleActivity, onDeleteActivity } = useActivityActions({
    courseId,
  });

  const handleCreateActivity = useCallback(() => {
    history.push(`/${courseId}/activities/create`);
  }, [history, courseId]);

  const handleEditActivity = useCallback(
    (activity: ProfessorActivity) => {
      history.push(`/${courseId}/activities/${activity.id}/edit`);
    },
    [history, courseId]
  );

  const handleActivityClick = useCallback(
    (activity: ProfessorActivity) => {
      history.push(`/${courseId}/activities/${activity.id}/details/answers`);
    },
    [history, courseId]
  );

  const speedDialOptions = useMemo(
    () => [
      {
        icon: <CreateIcon />,
        title: 'Crear Tarea',
        onClick: handleCreateActivity,
      },
    ],
    [handleCreateActivity]
  );

  return (
    <>
      <ToMainMenuButton title={intl.formatMessage({ id: 'quickLink.activities' })} />
      <Box mt={2}>
        <ActivitiesTable
          activities={activities}
          loading={loading}
          onClickActivity={handleActivityClick}
          onEditActivity={handleEditActivity}
          onToggleActivity={onToggleActivity}
          onDeleteActivity={onDeleteActivity}
        />
      </Box>
      <SpeedDialMenu options={speedDialOptions} />
    </>
  );
};

export default ActivitiesPage;
